import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const CONNECTOR_FILES_QUERY_KEY = '/rest/files/list';
export const CONNECTOR_FILES_INFINITE_QUERY_KEY = '/rest/files/list-infinite';
export const CONNECTOR_HAS_UPLOADED_FILES_QUERY_KEY = '/rest/files/has-uploaded';
export const getListConnectorFilesQueryKey = (request, 
/*
 * isForInfiniteQuery alters the query key so it may be used in useInfiniteQuery.
 * It appends -infinite to the first element.
 */
isForInfiniteQuery) => request
    ? QueryClientHelper.makeQueryKey(isForInfiniteQuery ? CONNECTOR_FILES_INFINITE_QUERY_KEY : CONNECTOR_FILES_QUERY_KEY, request)
    : QueryClientHelper.makeQueryKey(isForInfiniteQuery ? CONNECTOR_FILES_INFINITE_QUERY_KEY : CONNECTOR_FILES_QUERY_KEY);
export const getSharepointSitesQueryKey = (filters, connectionUuid) => QueryClientHelper.makeQueryKey('/rest/connectors/sharepoint/sites', {
    ...(filters ?? {}),
    connection_uuid: connectionUuid ?? null,
});
export const REPOSITORY_UPLOAD_STATES_QUERY_KEY = '/rest/file-repository/uploads';
export const getRepositoryUploadStatesQueryKey = (fileRepositoryInfo) => QueryClientHelper.makeQueryKey(REPOSITORY_UPLOAD_STATES_QUERY_KEY, fileRepositoryInfo);
export const SPACE_FILE_ERRORS_QUERY_KEY = '/rest/files/list-errors';
export const getImageDownloadUrlQueryKey = (url) => QueryClientHelper.makeQueryKey('download-image-url', ...(url ? [url] : []));
//# sourceMappingURL=fileKeys.js.map